module.exports = __webpack_public_path__ + "static/fonts/DingTalk-JinBuTi.faa33a7.woff";